
















































import { Component, Vue, Watch } from 'vue-property-decorator'
import ffHeader from '@/components/public/Header.vue'
import { Route } from 'vue-router'
import { Toast } from 'vant'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
const appStore = namespace('app')
@Component({
  components: {
    ffHeader
  }
})
export default class Layout extends Vue {
  private navShow: boolean = false
  private isNav: boolean = false
  private rewardsNav: boolean = false
  @appStore.State((state) => state.config) private config: any
  @appStore.State((state) => state.transify) private transify: any
  @appStore.State((state) => state.downloadOpen) private downloadOpen: boolean
  @appStore.State((state) => state.feedbackOpen) private feedbackOpen: boolean
  @appStore.State((state) => state.apkLink) private apkLink: string
  @appStore.State((state) => state.gameLogin) private gameLogin: boolean
  @appStore.Action('logout') private logout!: Function
  @Watch('$route')
  toggleRouter(val: Route): void {
    if (val.path === '/' || val.path === '/register') {
      this.isNav = false
    } else {
      this.isNav = true
      if (val.path === '/rewards') {
        this.rewardsNav = true
      } else {
        this.rewardsNav = false
      }
    }
  }
  get initNav(): Array<object> {
    let navList: Array<object> = []
    navList.push({
      title: this.transify['ADV_MENU_DOWNLOAD'],
      path: '/download'
    })
    navList.push({
      title: this.transify['ADV_MENU_PROFILE'],
      path: '/profile'
    })
    navList.push({
      title: this.transify['ADV_MENU_BUG'],
      path: '/feedback'
    })
    navList = navList.concat([
      {
        title: this.transify['ADV_MENU_HISTORY'],
        path: '/profile'
      },
      {
        title: this.transify['ADV_MENU_REWARDS'],
        path: '/rewards'
      },
      {
        title: this.transify['ADV_MENU_LOGOUT'],
        path: '/logout'
      }
    ])
    return navList
  }
  toggleNav(): void {
    this.navShow = !this.navShow
  }
  pustRouter(path: any) {
    if (path === '/logout') {
      this.logout().then(() => {
        this.closeNav()
        this['$router'].push({ path: '/' }).catch(() => {
          return
        })
      })
      return
    }
    if (path === '/feedback') {
      if (!this.feedbackOpen) return
      if (!this.gameLogin) {
        Toast(this.transify['ADV_DOWNLOAD_REPORTBUG_HINT'])
        return
      }
    }
    this.closeNav()
    this['$router'].push(path).catch(() => {
      return
    })
  }
  closeNav(): void {
    this.navShow = false
  }
  mounted(): void {
    this.toggleRouter(this['$route'])
  }
}
